import { userConstants } from '../../_constants';

export function users(state = {}, action) {
    switch (action.type) {
        case userConstants.USER_FETCHING:
            return {
                ...state,
                userFetching: true
            };
        case userConstants.USER_FETCHED:
            return {
                ...state,
                userFetching: false
            };
        case userConstants.USER_SUBMITTING:
            return {
                ...state,
                userSubmitting: true
            };
        case userConstants.USER_SUBMITTED:
            return {
                ...state,
                userSubmitting: false
            };
        case userConstants.GET_USERS:
            return {
                ...state,
                users: action.users
            };
        case userConstants.GET_USER_BY_ID:
            return {
                ...state,
                user: action.user
            };
        case userConstants.GET_USER_BY_ID_LOGIN:
            return {
                ...state,
                userlogin: action.userlogin
            };
        case userConstants.SETUP_USER:
            return {
                ...state,
                fetching: false
            };
        case userConstants.LOGIN_USER_SUCCESS:
            return {
                ...state,
                user: action.user
            };
        case userConstants.LOGIN_USER_FAIL:
            return {
                ...state,
                fetching: false
            };
        case userConstants.CHANGE_PASSWORD:
            return {
                ...state,
                changePassword: true
            };
        case userConstants.CURRENT_VERSION:
            return {
                ...state,
                currentVersion: action.currentVersion
            };
        case userConstants.ALLOW_LEAVE_PAGE:
            return {
                ...state,
                allowLeavePage: false,
            };
        case userConstants.NOT_ALLOW_LEAVE_PAGE:
            return {
                ...state,
                allowLeavePage: true,
            };
        case userConstants.CHANGE_PASSWORD_ADMIN:
            return {
                ...state,
                changePasswordAdmin: true
            };
        default:
            return state;
    }
}